// extracted by mini-css-extract-plugin
export default {"DownloadAssetLink":"DownloadAssetLink__DownloadAssetLink___tqt0b","icon":"DownloadAssetLink__icon___VhU0X"};